import type { ChatContext } from "../../ai-chat";
import type { CompanyData } from "./types";

export function buildCompanyContext(data: CompanyData): ChatContext {
  return {
    surface: "company",
    company: {
      netProfit: data.netProfit,
      operatingProfit: data.operatingProfit,
      avgRoas: data.avgRoas,
      avgCpa: data.avgCpa,
      totalRevenue: data.totalRevenue,
      grossRevenue: data.grossRevenue,
      collectedRevenue: data.collectedRevenue,
      totalVariableCosts: data.totalVariableCosts,
      totalLogisticsCosts: data.totalLogisticsCosts,
      pendingRevenue: data.pendingRevenue,
      estimatedPendingProfit: data.estimatedPendingProfit,
      estimatedTotalProfit: data.estimatedTotalProfit,
      totalAdInvestment: data.totalAdInvestment,
      matchedAdInvestment: data.matchedAdInvestment,
      unassignedAdInvestment: data.unassignedAdInvestment,
      totalFixedCosts: data.totalFixedCosts,
      revenueByPaymentMethod: data.revenueByPaymentMethod,
      cpaTargets: data.cpaTargets,
      fixedCostsCurrency: data.fixedCostsCurrency,
      fixedCosts: data.fixedCosts.map((cost) => ({
        label: cost.label,
        amount: cost.amount,
        currency: cost.currency ?? data.fixedCostsCurrency,
      })),
      funnels: data.funnels.map((funnel) => ({
        funnelName: funnel.funnelName,
        productName: funnel.productName,
        revenue: funnel.revenue,
        profit: funnel.profit,
        marginPct: funnel.marginPct,
      })),
    },
  };
}
